var map = {
	"./ARB.png": 3073,
	"./BNB.png": 3464,
	"./CAKE.png": 2983,
	"./ETH.png": 1462,
	"./FTM.png": 7157,
	"./LUNA.png": 5003,
	"./MATIC.png": 5172,
	"./SWPL.png": 2788,
	"./old/BNB.png": 1106,
	"./old/ETH.png": 5935
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5721;